<script lang="ts">
    import type { Availability as AvailabilityType } from '@shared/types/types';
    import Availability from '../availability/Availability.svelte';
    import OttoUp from '../otto-up/OttoUp.svelte';

    interface Props {
        availability: AvailabilityType | undefined;
        ottoUp: boolean | undefined;
    }

    let { availability, ottoUp }: Props = $props();
</script>

{#if availability || ottoUp}
    <div class="reptile-availability">
        <Availability {availability} />
        <OttoUp show={ottoUp} />
    </div>
{/if}

<style lang="scss">
    @use '@otto-ec/design-tokens/tokens';

    .reptile-availability {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-between;
        gap: tokens.$oc-semantic-spacing-50;
        width: 100%;
    }
</style>
